module.exports = __webpack_public_path__ + "static/img/xinnengyuan1.1abaccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xinnengyuan1.png
// module id = sOmP
// module chunks = 16